import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { categories } from "@/mocks/siteData";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <section className="relative w-full px-4 md:px-8 py-20 md:py-28 bg-background-50 overflow-hidden">
        <span
          aria-hidden="true"
          className="absolute -top-6 right-4 md:right-10 font-heading font-black text-[7rem] md:text-[11rem] text-background-200 select-none pointer-events-none"
        >
          404
        </span>
        <div className="relative max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 mb-4 uppercase">
            <span className="w-6 h-px bg-primary-400"></span>
            Page not found
          </p>
          <h1 className="font-heading font-black text-3xl md:text-5xl leading-tight text-foreground-950">
            这个页面还没被收录
          </h1>
          <p className="mt-4 text-sm md:text-lg leading-relaxed text-foreground-600">
            你访问的地址可能已经调整，或者事件整理仍在编辑中。
            <span className="block mt-2 text-xs text-foreground-500 font-mono break-all">{location.pathname}</span>
          </p>

          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center gap-1.5 h-11 px-5 rounded-md border border-background-300 text-sm text-foreground-800 whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors"
            >
              <i className="ri-list-check-2"></i>
              浏览全部事件
            </Link>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200">
            <h2 className="text-sm text-foreground-500 mb-3">也许你想找的是这些分类</h2>
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category?cat=${cat.slug}`}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  <i className={cat.icon}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}